module.exports = __webpack_public_path__ + "img/poland.cb55ad05.svg";